module.exports = __webpack_public_path__ + "img/googleNewFont.3ce5f09f.svg";